import { useLang } from "../i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="relative py-10 md:py-14 border-y border-[#D4AF37]/15 overflow-hidden bg-[#0B0A08]" data-testid="marquee">
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0 items-center" aria-hidden={k === 1}>
            {items.map((m, i) => (
              <span key={i} className="flex items-center font-display text-5xl md:text-7xl text-transparent stroke-text whitespace-nowrap px-8">
                {i % 2 ? <em className="text-gold-grad not-italic font-display italic">{m}</em> : m}
                <span className="ml-16 text-[#D4AF37] text-2xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
